import React, { useMemo } from "react";
import ReactECharts from "echarts-for-react";
import useCommonStore from "../../../store/CommonStore";
import { generateXAxisLabels } from "../../../common/Constants";

interface TrendChartProps {
  filteredData: any;
  loadingStates?: boolean;
}

const TrendChart: React.FC<TrendChartProps> = ({
  filteredData,
  loadingStates,
}) => {
  const { selectedValue } = useCommonStore();

  const xAxisLabels = useMemo(
    () => generateXAxisLabels(selectedValue),
    [selectedValue]
  );

  const chartData = useMemo(() => {
    if (!filteredData || filteredData.length === 0)
      return new Array(xAxisLabels.length).fill(0);

    const counts = new Array(xAxisLabels.length).fill(0);

    filteredData?.forEach((item: any) => {
      // const dateField = item?.created_at ?? item?.last_modified ?? null;
      const dateField =
        item?.last_modified ??
        item?.session_created_at ??
        item?.created_at ??
        null;

      if (!dateField) return;

      const dateObj = new Date(dateField);
      if (isNaN(dateObj.getTime())) return;

      const today = new Date();
      const diffInDays = Math.floor(
        (today.getTime() - dateObj.getTime()) / (1000 * 60 * 60 * 24)
      );

      const index = xAxisLabels.length - 1 - diffInDays;

      if (index >= 0 && index < xAxisLabels.length) {
        counts[index] += 1;
      }
    });

    return counts;
  }, [filteredData, xAxisLabels]);

  // const chartOptions = {
  //   xAxis: {
  //     type: "category",
  //     data: xAxisLabels,
  //     axisLine: { show: false },
  //     axisTick: { show: false },
  //     axisLabel: { show: false },
  //   },
  //   yAxis: {
  //     type: "value",
  //     axisLine: { show: false },
  //     axisTick: { show: false },
  //     axisLabel: { show: false },
  //     splitLine: { show: false },
  //   },
  //   grid: { left: 0, right: 0, top: 0, bottom: 0 },
  //   series: [
  //     {
  //       type: "line",
  //       smooth: true,
  //       data: chartData,
  //       lineStyle: {
  //         color: "#4169E1",
  //         width: 2,
  //         display: "flex",
  //         alignItems: "flex-end",
  //       },
  //       showSymbol: false,
  //     },
  //   ],
  // };

  const chartOptions = {
    tooltip: {
      trigger: "axis",
      formatter: (params: any) => {
        const dataPoint = params[0];
        const date = dataPoint.axisValue;
        const value = dataPoint.data;
        return `${date}: ${value}`;
      },
      backgroundColor: "#fff",
      borderColor: "#ccc",
      borderWidth: 1,
      textStyle: {
        color: "#333",
      },
    },
    xAxis: {
      type: "category",
      data: xAxisLabels,
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: { show: false },
    },
    yAxis: {
      type: "value",
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: { show: false },
      splitLine: { show: false },
    },
    grid: { left: 0, right: 0, top: 0, bottom: 0 },
    series: [
      {
        type: "line",
        smooth: true,
        data: chartData,
        lineStyle: {
          color: "#4169E1",
          width: 2,
          display: "flex",
          alignItems: "flex-end",
        },
        showSymbol: false,
      },
    ],
  };

  return (
    <div
      style={{
        width: "120px",
        height: "50px",
      }}
    >
      <ReactECharts
        option={chartOptions}
        style={{
          width: "100%",
          height: "100%",
        }}
      />
    </div>
  );
};

export default TrendChart;
